import { render } from "./pos-register.vue?vue&type=template&id=2ebd6acd"
import script from "./pos-register.vue?vue&type=script&lang=js"
export * from "./pos-register.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__